export default __webpack_public_path__ + "3c655e00a8c7560afc99d8f413fdf030.svg";